import { Helmet } from "react-helmet-async"
import { useOutletContext } from "react-router"
import { OAuthAppSetup, TOAuthIntegration } from "../../../../../Integrations"

export default function OAuthIntegrationSetupPage() {
	const context = useOutletContext<{ integration: TOAuthIntegration }>()

	return (
		<>
			<Helmet>
				<title>Setup | OAuth App</title>
			</Helmet>
			<OAuthAppSetup integration={context.integration} />
		</>
	)
}
